const GROUP = 'G';
const USER = 'U';

export default {
  GROUP,
  USER
};
